<ng-container *ngIf="chatbotEnabled" >
    <script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
    <!-- CHATBOT INTEGRATION -->
<!--    <script src="${commonResourcePath}/${siteUid}-chatbot/chatbot_script.js"></script>-->
    <ng-container *ngIf="baseSiteId === 'vax'">
        <link rel="stylesheet" type="text/css" href="/assets/chatbot/vax-chatbot/chatbot_styles.css">
    </ng-container>
    <ng-container *ngIf="baseSiteId === 'vsh'">
        <link rel="stylesheet" type="text/css" href="/assets/chatbot/vsh-chatbot/chatbot_styles.css">
    </ng-container>


    <!-- ####  TALK BUBBLE START #### -->
    <div class="chatbot-talk-bubble chatbot-tri-right chatbot-btm-right" id="chatbot-talk-bubble" style="display: none;">
        <div class="chatbot-talktext">
            <span class="chatbot-talktexth3"><b>Hello, I&#39;m {{agentName}}!<BR>What can I help you learn more about today?</b></span>
        </div>
    </div>
    <!-- ####  TALK BUBBLE END #### -->
    <!-- ####  INSTERSTITIAL START #### -->
    <!-- INSTERSTITIAL CONTENT AREA -->
    <div id="wa_insterstitial_area">
        <!-- CONTENT PAGE -->
        <div id="wa_insterstitial_content" vertical-align="top">
            <!-- *************************** -->
            <img id="wa_insterstitial_image" src="" style="max-width:100%;" />
            <!-- *************************** -->
        </div>
    </div>
    <!-- INSTERSTITIAL DARK FADE  -->
    <div id="wa_insterstitial_fade" onClick="wa_insterstitial_close();">
        <div id="wa_insterstitial_closebutton" class="wa_insterstitial_closebutton">X</div>
    </div>
    <!-- ####  INSTERSTITIAL END #### -->
    <!-- END CHATBOT INTEGRATION -->
</ng-container>